// extracted by mini-css-extract-plugin
module.exports = {"swiper-slide-card":"swiper-slide-card","swiper_span":"swiper_span","swiper_btn":"swiper_btn","btn_icon":"btn_icon","swiper_img":"swiper_img","title_img":"title_img"};